export default __webpack_public_path__ + "static/media/questionmark.519c0195.svg";